import styled, { css } from "styled-components"
import { styles as h3styles } from "../../typography/h3/styles"

export const StyledFieldset = styled.fieldset`
  border: none;
  margin: 0;
  padding: 0;

  ${({ last, simpleForm }) =>
    !!last &&
    !!simpleForm &&
    css`
      margin-bottom: 32px;
    `}
`

export const Legend = styled.legend`
  ${h3styles}

  margin: 0 0 1rem;
  padding: 0;
`

export const VideoHintList = styled.div`
  line-height: 1.5em;
  padding: 0 0 0 20px;
  text-decoration: underline;

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      color: ${({ theme }) => theme.colors.fields.text};
    `}
`

export const VideoHintP = styled.p`
  margin: -5px 0 0;

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      color: ${({ theme }) => theme.colors.fields.text};
    `}
`
export const VideoHintHeading = styled.div`
  margin: 1rem 0 -3px;
  font-weight: bold;

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      color: ${({ theme }) => theme.colors.primary};
    `}
`
